module.exports = __webpack_public_path__ + "static/media/logo.ed967507.png";